<template>
  <div>
    <template v-if="this.$route.path !== '/personal/center/set'">
      <!-- 我的信息 -->
      <h3>
        我的信息
        <p class="fr timeinfo">上一次登录：{{ userInfo.lastLoginTime }}</p>
      </h3>
      <div class="userNormalInfo">
        <h5 class="infoTitle">
          <!--  <img src="~img/logo.png" alt="" />
        我的基本信息 -->
        </h5>
        <ul class="infolist">
          <li>用户ID：{{ userInfo.id }}</li>
          <li>
            用户昵称： {{ userInfo.name
            }}<em
              >你有一次设置昵称的机会，请点击<a
                href="javaScript:"
                class="setInfo"
                @click="setting"
                >设置</a
              ></em
            >
          </li>
          <li>
            收藏书籍：{{ userInfo.bookShelf }}本<em
              ><a href="javaScript:" @click="gocollect">查看我的书架</a></em
            >
          </li>
          <li>
            当前余额：{{ userInfo.yuanBi }} 源币 &nbsp;|&nbsp;{{
              userInfo.coin
            }}
            赠币<em
              ><routerLink to="/personal/myAccount">去充值</routerLink></em
            >
          </li>
          <li class="record">
            <router-link
              style="color:#999"
              to="/personal/myAccount/rechargeRecord"
            >
              充值记录
            </router-link>
            |
            <router-link
              style="color:#999"
              to="/personal/myAccount/expenseRecord"
              >消费记录</router-link
            >
          </li>
        </ul>
      </div>
      <!-- <div class="infoline"></div> -->
      <div>
        <h3>
          <router-link class="clearfix" to="/bookStack">
            猜你喜欢
            <p class="fr" @click="gostackBook">
              更多<img src="~img/personal/rightarrow.png" alt="" />
            </p>
          </router-link>
        </h3>
        <smallSixRecommend :booklist="shelf1"></smallSixRecommend>
        <!-- <div class="searchbox ">
          <span>没找到自己感兴趣的？来这里搜一搜！</span>
          <div class="searchInput clearfix">
            <input type="text" placeholder="请输入小说名" class="fl" />
            <button class="fl">搜索</button>
          </div>
        </div> -->
      </div>
    </template>
    <router-view></router-view>
  </div>
</template>

<script>
import { getuserInfo } from "@/api/login";
import { moreshelf } from "@/api/book";
export default {
  metaInfo: {
    title: "个人中心-源石阅读"
  },
  data() {
    return {
      booklist: [],
      userInfo: {},
      shelf1: []
    };
  },
  created() {
    this.$nextTick(() => {
      // 获取用户信息
      this.getInfo();
      // shelf
      this.getmoreshelf();
    });
  },
  methods: {
    getmoreshelf() {
      moreshelf({ shelfId: "yuanshi_web_guess_like" }).then(res => {
        if (res.success) {
          this.shelf1 = res.data.items;
          this.shelf1.forEach(items => {
            items.introduce = items.introduce.substring(0, 40) + "...";
          });
        }
      });
    },
    setting() {
      this.$router.push("/personal/center/set");
    },
    // 获取用户信息
    async getInfo() {
      let res = await getuserInfo();
      if (res.success) {
        this.userInfo = res.data;
      }
    },
    gocollect() {
      this.$router.push("/personal/collect");
    },
    gostackBook() {
      this.$router.push("/bookStack");
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/styles/cominxin.styl'
.userNormalInfo
    .infolist
        margin-left 24px
        font-weight 400
        color rgba(71, 71, 71, 1)
        margin-bottom 20px
        li
            margin-bottom 11px
            &.record
                font-size 12px
                color rgba(153, 153, 153, 1)
                margin-bottom 0px
            em
                margin-left 40px
                font-size 12px
                color #0EA3E5
                a
                    font-size 12px
                    color #48A2DF
                    text-decoration underline
                    &.setInfo
                        padding 2px 3px
                        background:rgba(72,162,223,1);
                        border-radius:2px;
                        color #fff
                        text-decoration none
                        margin-left 3px
.infoline
    width 737px
    border-top 1px solid #E5E5E5
    margin 24px 45px 24px 38px
.searchbox
    text-align center
    font-size 12px
    color rgba(108, 108, 108, 1)
    height 27px
    line-height 27px
    margin-bottom 20px
    span
        display inline-block
        vertical-align top
        padding-right 20px
    .searchInput
        display inline-block
        input
            width 262px
            height 27px
            background rgba(238, 238, 238, 1)
            border-radius 4px 0px 0px 4px
            border none
            padding 0
            padding-left 17px
            placeMain(#999999, 12px)
        button
            width 55px
            height 27px
            background rgba(72, 162, 223, 1)
            border-radius 0px 4px 4px 0px
            color #ffffff
            border none
            font-size 12px
</style>
